import React, { useEffect } from "react"
import { Container } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import Breadcrumb from "components/Common/Breadcrumb"
import InvestorUsersTable from "./table"

const InvestorUsers = () => {
  const { permissions } = useSelector((state) => state.user)
  const navigate = useNavigate()

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.includes("USERS_LIST")
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Users"} breadcrumbItem={"Roles"} />
          <InvestorUsersTable />
        </Container>
      </div>
    </>
  )
}

export default InvestorUsers
